import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsPurchasesFuel from './endpoints'

export const SuppliersService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsPurchasesFuel.LOAD(filter, sort, limit, skip)),
  create: async (body) => POST(endpointsPurchasesFuel.CREATE, body),
  getById: async (id) => GET(endpointsPurchasesFuel.BY_ID(id)),
  update: async ({ _id, body }) =>
    PATCH(endpointsPurchasesFuel.BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsPurchasesFuel.BY_ID(id)),
}
